/**
 * Shared helpers for step summary renderers
 */

export function getString(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined;
}

export function getNumber(value: unknown): number | undefined {
  return typeof value === "number" ? value : undefined;
}

export function getBool(value: unknown): boolean {
  return value === true;
}

const SENSITIVE_HEADER_PATTERNS = [
  "authorization",
  "x-api-key",
  "api-key",
  "apikey",
  "token",
  "secret",
  "password",
  "credential",
  "bearer",
  "x-auth",
  "x-token",
  "x-secret",
  "access-key",
  "accesstoken",
];

export function isSensitiveHeader(headerName: string): boolean {
  const lower = headerName.toLowerCase();
  return SENSITIVE_HEADER_PATTERNS.some((p) => lower.includes(p));
}

export function maskHeaderValue(value: string): string {
  if (value.length <= 4) return "****";
  return value.slice(0, 4) + "********";
}
